// extracted by mini-css-extract-plugin
export default {"feedback":"styles_feedback__d01pU","answer":"styles_answer__FEmH+"};